import { useContext } from 'react';
import { WalletContext } from '.';

export const useWallet = () => {
	return useContext(WalletContext);
};
